import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

import styles from "./AccordionDetails.module.scss";

const Empty: React.FC<{ messge: string }> = ({ messge }) => {
  return (
    <div className={styles.emptyDetails}>
      <WarningAmberRoundedIcon /> <label>{messge}</label>
    </div>
  );
};

export default Empty;
